import moment from 'moment-timezone';
import { FONT_FAMILY } from '@utils/constants';
import { TOOLTIP_LABEL_FORMAT } from '@components/common/Charts/utils';
import { darken, lighten } from 'polished';
import * as echarts from 'echarts';
import { getMetricShortName, getMetricUnitByKey } from '@utils/metrics';
import humanizeUtil, { humanize } from '@utils/humanizeUtil';

export const buildMultiChartOption = ({ data, metrics, colorMap, legendMap = null }) => {
  // unit will be same for multi series
  const unit = getMetricUnitByKey({ metricKey: metrics[0] });

  const tooltipFormatter = (params) => {
    const timeLabel = moment(params[0].data[0]).format(TOOLTIP_LABEL_FORMAT);
    const out = params.map((rec) => {
      const value = rec.data;
      const { humanizedNumber, humanizedUnit } = humanizeUtil(value[1], metrics[0], unit);
      return `${rec.marker} ${rec.seriesName} - <b>${humanizedNumber} ${humanizedUnit}</b>`;
    });
    return `${timeLabel}<br/>${out.join('<br/>')}`;
  };

  const option: any = {
    _viewType: 'timeseries',
    grid: {
      left: 25,
      bottom: 50,
      right: 20,
      top: 10,
    },
    legend: {
      type: 'scroll',
      bottom: 0,
      lineStyle: {
        width: 0,
      },
      orient: 'horizontal',
      textStyle: {
        fontSize: 10,
      },
    },
    tooltip: {
      trigger: 'axis',
      formatter: tooltipFormatter,
      font: FONT_FAMILY,
      appendToBody: true,
      className: 'echarts-tooltip',
    },
    xAxis: [
      {
        type: 'time',
        axisLabel: {
          formatter: (value) => {
            return moment(value).format('HH:mm');
          },
        },
      },
    ],
    yAxis: [
      {
        type: 'value',
        splitNumber: 2,
        axisLabel: {
          formatter: (value) => humanize(value),
        },
      },
    ],
    series: metrics.map((metricKey, idx) => ({
      id: metricKey,
      name: legendMap ? legendMap[metricKey] : getMetricShortName({ metricKey }),
      data: data[metricKey],
      type: 'line',
      showSymbol: false,
      color: colorMap[metricKey],
      areaStyle: {
        opacity: 0.25,
        //color: overviewFilterColors[idx],
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: lighten(0.2, colorMap[metricKey]),
          },
          {
            offset: 1,
            color: darken(0.1, colorMap[metricKey]),
          },
        ]),
      },
      emphasis: {
        areaStyle: {
          opacity: 0.8,
        },
      },
      lineStyle: {
        width: 1,
        color: colorMap[metricKey],
      },
    })),
  };
  return option;
};
